import t from "../../../locales/common.json";
import imageData from "../../../img/legal.svg";
import Featurette from "../../featurette/index.marko";
import FeaturetteBody from "../../featurette/body.marko";
import FeaturetteBodyText from "../../featurette/body-text.marko";
import FeaturetteHeading from "../../featurette/heading.marko";
import FeaturetteTitle from "../../featurette/title.marko";

static const link = "/legal";

<enclosed-section>
  <Featurette>
    <FeaturetteHeading>
      <a href=link>
        <image-fluid src=imageData alt=t.cc.Services.consulate.title/>
      </a>
    </FeaturetteHeading>
    <FeaturetteBody>
      <FeaturetteTitle>
        ${
          t.cc.Services.consulate.title + " " + t.cc.Services.consulate.subtitle
        }
      </FeaturetteTitle>
      <FeaturetteBodyText>
        <u-list>
          <for|item| of=t.cc.Services.consulate.list>
            <li>${item}</li>
          </for>
        </u-list>
      </FeaturetteBodyText>
      <div class="flex justify-content-center justify-content-start-lg">
        <button-link style={ "max-width": "fit-content" } href=link>
          ${t.cc.Services.showMore}
        </button-link>
      </div>
    </FeaturetteBody>
  </Featurette>
</enclosed-section>
